export default {
  SET_REQUESTID(state, requestid) {
    state.requestid = requestid;
  },
  SET_INSTANCEID(state, instanceid) {
    state.instanceid = instanceid;
  }
};
